import { getSlotProviderName } from 'modules/SlotsRoot/providersData/GameCatalog/GameCatalogUtils'
import { uniqGameId } from 'modules/SlotsRoot/providersData/GameCatalog/uniqGameId'
import { Providers } from 'modules/SlotsRoot/types/configuration'
import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

import { IConvertGameList, ISlotConverter } from '../../types/converter'
import { getTab, getTabLive } from '../Softswiss/SoftwissUtils'
import { SoftgamingResponse, SoftgamingServerGame } from './types'

export class SoftgamingConverter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<SoftgamingResponse>): ISlotViewItem[] =>
    data.games.map((item: SoftgamingServerGame) => {
      const provider = getSlotProviderName({
        game_type: item.game_type as any,
        integration: item.integration as any,
        producer: item.producer,
        provider: item.provider,
      } as any)
      const gameId = uniqGameId(Providers.SoftGaming, item.provider, String(item.game_id))

      return {
        id: String(item.id),
        gameId,
        description: '',
        gameName: item.name,
        tab: getTab(gameId, item.name),
        tabLive: getTabLive(gameId),
        provider,
        imageUrl: item.image || '',
        routeProvider: Providers.SoftGaming,
        additionalData: {
          system: item.slug?.split('/')?.[0],
        },
        hasDemoMode: true,
      }
    })

  convertGameUrl = ({ data }: { data: string | { url: string } }) => {
    const convertedData = typeof data === 'string' ? data : data?.url
    if (convertedData?.toString().trim().startsWith('<')) {
      const blob = new Blob([convertedData], { type: 'text/html' })
      return URL.createObjectURL(blob)
    }
    return convertedData
  }
}

export default SoftgamingConverter
